<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont1">{{
        $t("schedulingAndPricing.schedulingAndPricing")
      }}</span>
    </p>
    <el-form
      class="systemFont2 systemForm1"
      ref="schedulingAndPricingFormRef"
      :model="schedulingAndPricingForm"
      label-width="106px"
      hide-required-asterisk
    >
      <el-row>
        <el-col :span="8" :offset="2">
          <el-form-item :label="$t('courseOption.field')">
            <el-select
              v-model="schedulingAndPricingForm.field"
              size="systemSelect3"
              style="width: 100%"
              disabled
              placeholder=""
            >
              <el-option
                :label="fieldOption.label"
                :value="fieldOption.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('courseOption.courseName')">
            <el-input
              v-model="schedulingAndPricingForm.courseName"
              size="reportContentInput"
              :disabled="true"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <el-form-item
            :label="$t('courseOption.targetStudents')"
            class="formItem"
          >
            <el-input
              v-model="schedulingAndPricingForm.targetStudents"
              type="textarea"
              size="reportLongContentInput"
              rows="3"
              :disabled="true"
              maxlength="600"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <el-form-item :label="$t('courseOption.classLanguage')">
            <el-select
              v-model="schedulingAndPricingForm.classLanguage"
              size="systemSelect3"
              style="width: 100%"
              disabled
              placeholder=""
            >
            </el-select>
          </el-form-item>
          <!-- 证书 -->
          <el-form-item :label="$t('courseOption.certificate')">
            <el-input
              v-model="schedulingAndPricingForm.certificate"
              size="reportContentInput"
              :disabled="true"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 选择课程 -->
          <el-form-item style="text-align: left">
            <el-radio-group v-model="radioButton">
              <el-radio label="0" @change="changePrice0">{{
                $t("courseOption.normalCourses")
              }}</el-radio>
              <el-radio label="1" @change="changePrice1">{{
                $t("courseOption.freeCourses")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('schedulingAndPricing.unitPrice')">
            <el-col :span="11">
              <el-form-item
                label-width="0px"
                prop="unitPrice"
                :rules="unitPrice"
              >
                <el-input
                  :disabled="radioButton == 1"
                  size="reportContentInput"
                  v-model="schedulingAndPricingForm.unitPrice"
                  maxlength="10"
                  :placeholder="$t('common.required')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item label-width="0px">
                <el-select
                  :disabled="radioButton == 1"
                  v-model="schedulingAndPricingForm.currency"
                  size="systemSelect3"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in currencyList"
                    :key="item.codeKey"
                    :label="item.codeValueZh"
                    :value="item.codeKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('courseOption.form')">
            <el-select
              v-model="schedulingAndPricingForm.formCode"
              size="systemSelect3"
              style="width: 100%"
              placeholder=""
            >
              <el-option
                v-for="item in selection.filter(
                  item => item.searchKey === 'form' && item.codeKey !== '02'
                )"
                :key="item.codeKey"
                :label="item.codeValueZh"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 上课链接/视频链接 -->
          <el-form-item
            :label="
              formFlag
                ? $t('schedulingAndPricing.classLink')
                : $t('schedulingAndPricing.videoLink')
            "
            prop="classLink"
            :rules="classLink"
          >
            <el-input
              v-model="schedulingAndPricingForm.classLink"
              size="reportContentInput"
              maxlength="500"
            ></el-input>
          </el-form-item>
          <!-- 会议号 -->
          <el-form-item
            v-if="formFlag"
            :label="$t('schedulingAndPricing.meetingId')"
            prop="meetingId"
          >
            <el-input
              v-model="schedulingAndPricingForm.meetingId"
              size="reportContentInput"
              maxlength="500"
            ></el-input>
          </el-form-item>
          <!-- 会议密码/视频密码 -->
          <el-form-item
            :label="
              formFlag
                ? $t('schedulingAndPricing.linkPassword')
                : $t('schedulingAndPricing.videoPassword')
            "
            prop="linkPassword"
            :rules="linkPassword"
          >
            <el-input
              v-model="schedulingAndPricingForm.linkPassword"
              size="reportContentInput"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('p0321.requiredOptions')"
            style="text-align:left"
          >
            <el-checkbox
              v-model="schedulingAndPricingForm.signupSetting.sexIsRequired"
              :label="$t('p0321.title')"
            ></el-checkbox>
            <el-checkbox
              v-model="schedulingAndPricingForm.signupSetting.phoneIsRequired"
              :label="$t('p0321.phone')"
            ></el-checkbox>
            <el-checkbox
              v-model="schedulingAndPricingForm.signupSetting.companyIsRequired"
              :label="$t('p0321.company')"
            ></el-checkbox>
            <el-checkbox
              v-model="
                schedulingAndPricingForm.signupSetting.positionIsRequired
              "
              :label="$t('p0321.position')"
            ></el-checkbox>
            <el-checkbox
              v-if="radioButton !== '1'"
              v-model="
                schedulingAndPricingForm.signupSetting.birthdayIsRequired
              "
              :label="$t('p0321.birthday')"
            ></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <div style="height: 445px"></div>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('courseOption.category')">
            <el-select
              v-model="schedulingAndPricingForm.category"
              size="systemSelect3"
              style="width: 100%"
              disabled
              placeholder=""
            >
              <el-option
                :label="categoryOption.label"
                :value="categoryOption.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('courseOption.courseNumber')">
            <el-input
              v-model="schedulingAndPricingForm.courseNumber"
              size="reportContentInput"
              :disabled="true"
              maxlength="4"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <el-form-item
            :label="$t('courseOption.qualificationRequirements')"
            class="formItem"
          >
            <el-input
              type="textarea"
              v-model="schedulingAndPricingForm.qualificationRequirements"
              size="reportLongContentInput"
              rows="3"
              :disabled="true"
              maxlength="600"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <el-form-item :label="$t('courseOption.numberLimit')">
            <el-input
              v-model="schedulingAndPricingForm.numberLimit"
              size="reportContentInput"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <!-- 课件链接 -->
          <el-form-item :label="$t('courseOption.coursewareLink')">
            <el-input
              v-model="schedulingAndPricingForm.coursewareLink"
              size="reportContentInput"
              maxlength="500"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item style="height: 40px"> </el-form-item>
          <!-- 课程时长想改成天+小时+分钟 -->
          <el-form-item
            :label="$t('courseOption.duration')"
            :rules="minutesRule"
            prop="minutes"
          >
            <el-row>
              <el-col :span="8">
                <el-select
                  filterable
                  v-model="days"
                  size="systemSelect3"
                  style="width: calc(100% - 1.2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.days") }}
              </el-col>
              <el-col :span="8">
                <el-select
                  filterable
                  v-model="hours"
                  size="systemSelect3"
                  style="width: calc(100% - 2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in hourList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.hours") }}
              </el-col>
              <el-col :span="8">
                <el-select
                  filterable
                  v-model="minutes"
                  size="systemSelect3"
                  style="width: calc(100% - 2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in durationList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.minutes") }}
              </el-col>
            </el-row>
            <!-- <el-time-picker
              :disabled="nonEdit"
              v-model="detailForm.duration"
              format="HH:mm"
              value-format="HH:mm"
              :picker-options="{
                selectableRange: '00:01:00 - 04:00:00'
              }"
              @focus="timePickerFocus"
              @blur="timePickerBlur"
              size="systemTimeSelect"
              style="width: 100%"
              arrow-control
              :placeholder="$t('common.selectDuration')"
            >
            </el-time-picker> -->
          </el-form-item>
          <!-- 日期与时间 -->
          <el-form-item
            v-if="formFlag"
            :label="$t('schedulingAndPricing.dateAndTime')"
            prop="dateAndTime"
            :rules="dateAndTime"
          >
            <el-date-picker
              v-model="schedulingAndPricingForm.dateAndTime"
              size="systemFormDate"
              style="width: 100%"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              :placeholder="$t('common.pleaseSelect')"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 结束日期与时间 -->
          <el-form-item
            v-if="formFlag"
            :label="$t('schedulingAndPricing.endDateAndTime')"
            prop="endDateAndTime"
            :rules="endDateAndTime"
          >
            <el-date-picker
              v-model="schedulingAndPricingForm.endDateAndTime"
              size="systemFormDate"
              style="width: 100%"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              :placeholder="$t('common.pleaseSelect')"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 报名链接 -->
          <!-- <el-form-item
            :label="$t('schedulingAndPricing.signUpLink')"
            prop="signUpLink"
          >
            <el-input
              disabled
              v-model="schedulingAndPricingForm.signUpLink"
              size="reportContentInput"
              maxlength="360"
            >
            </el-input>
          </el-form-item> -->
          <!-- 地点 -->
          <el-form-item
            v-if="formFlag"
            :label="$t('courseOption.classAddress')"
            prop="classAddress"
            :rules="schedulingAndPricingForm.formCode == '03' ? classAddress : [{ required: false }]"
          >
            <el-input
              v-model="schedulingAndPricingForm.classAddress"
              size="reportContentInput"
              maxlength="360"
              :placeholder="schedulingAndPricingForm.formCode == '03' ? $t('common.required') : ''"
            ></el-input>
          </el-form-item>
          <!-- 老师 -->
          <el-form-item :label="$t('schedulingAndPricing.teachers')">
            <el-row
              v-for="(item, index) in schedulingAndPricingForm.teachersData"
              :key="index"
            >
              <el-form-item
                label-width="0px"
                :prop="`teachersData.${index}`"
                :rules="{
                  required: false,
                  validator: (rule, value, callback) => {
                    validateTeachers(rule, index, value, callback);
                  },
                  trigger: 'blur'
                }"
              >
                <el-select
                  v-model="schedulingAndPricingForm.teachersData[index]"
                  size="reportContentInput"
                  maxlength="20"
                  clearable
                  style="width:100%"
                  @change="teacherInputBlur(index)"
                >
                  <el-option
                    v-for="item in certifiedTrainersOptions"
                    :key="item.userId"
                    :label="item.lastName + item.firstName"
                    :value="item.userId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-form-item>
        </el-col>
        <!-- 按钮 -->
        <div :style="formFlag ? 'margin-top:446px' : 'margin-top: 365px'">
          <div
            v-for="(item, index) in schedulingAndPricingForm.teachersData"
            :key="index"
            style="height: 40px;"
          >
            <img
              v-if="
                index == 0 &&
                  certifiedTrainersOptions.length >
                    schedulingAndPricingForm.teachersData.length
              "
              class="add-icon"
              src="@/assets/add.svg"
              @click="add()"
            />
            <img
              v-if="index != 0"
              class="subtract-icon"
              src="@/assets/subtract.svg"
              @click="subtract(index)"
            />
          </div>
        </div>
      </el-row>
    </el-form>
    <el-row class="foot-container">
      <el-col :span="12">
        <el-button type="submit" @click.native.prevent="handleSubmit">{{
          $t("common.submit")
        }}</el-button>
      </el-col>
      <el-col :span="12">
        <el-button type="return" @click.native.prevent="handleReturn">{{
          $t("common.back")
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    var validateMinutes = (rule, value, callback) => {
      if (this.days + this.hours + this.minutes == 0) {
        callback(new Error(this.$t("courseOption.pleaseEnterDuration")));
      } else {
        callback();
      }
    };
    var dateAndTimeCheck = (rule, value, callback) => {
      if (!value) {
        // 请选择日期与时间
        return callback(
          new Error(this.$t("schedulingAndPricing.pleaseSelectDateAndTime"))
        );
      }
      this.$refs["schedulingAndPricingFormRef"].validateField("endDateAndTime");
      return callback();
    };
    var endDateAndTimeCheck = (rule, value, callback) => {
      if (!value) {
        // 请选择结束日期与时间
        return callback(
          new Error(this.$t("schedulingAndPricing.pleaseSelectEndDateAndTime"))
        );
      }
      let durations = String(
        Number(this.days * 24 * 60) +
        Number(this.hours * 60) +
        Number(this.minutes)
      );
      if (this.getDateDiff() <  durations) {
        return callback(
          // 结束日期与时间的间隔小于时长
          new Error(this.$t("schedulingAndPricing.msg1"))
        );
      } else {
        return callback();
      }
    };
    return {
      certifiedTrainersOptions: [],
      formVal: "",
      formFlag: true,
      //课程时长想改成天+小时+分钟---zhc
      // 时分秒
      durationList: [],
      hourList: [],
      dayList: [],
      // 时长校验
      minutesRule: {
        trigger: ["blur", "change"],
        validator: validateMinutes,
        type: "number"
      },
      days: 0,
      hours: 0,
      minutes: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // 表单数据
      schedulingAndPricingForm: {
        field: "",
        category: "",
        courseNumber: "",
        courseName: "",
        targetStudents: "",
        qualificationRequirements: "",
        form: "",
        formCode: "",
        classLanguage: "",
        duration: "",
        numberLimit: "",
        certificate: "",
        coursewareLink: "",
        unitPrice: "",
        currency: "",
        dateAndTime: "",
        endDateAndTime: "",
        meetingId: "",
        classLink: "",
        linkPassword: "",
        teachers: "",
        teachersData: [""],
        signUpLink: "",
        classAddress: "",
        signupSetting: {
          sexIsRequired: true,
          phoneIsRequired: true,
          companyIsRequired: true,
          positionIsRequired: true,
          birthdayIsRequired: true
        }
      },
      // 领域下拉框选项
      fieldOption: {
        value: "",
        label: ""
      },
      // 类别下拉框选项
      categoryOption: {
        value: "",
        label: ""
      },
      // 选择项数据
      selection: [],
      currencyList: [],
      radioButton: "0",
      ifDisabled: false,
      // 老师输入框的校验规则
      validateTeachers(rule, index, value, callback) {
        if (value) {
          let rules = /^[^,]+$/;
          if (!rules.test(value)) {
            return callback(
              new Error(this.$t("schedulingAndPricing.pleaseDoNotEnterCommas"))
            );
          } else {
            for (
              let i = 0;
              i < this.schedulingAndPricingForm.teachersData.length;
              i++
            ) {
              if (
                i != index &&
                this.schedulingAndPricingForm.teachersData[i] != ""
              ) {
                if (this.schedulingAndPricingForm.teachersData[i] == value) {
                  return callback(
                    new Error(
                      this.$t("schedulingAndPricing.duplicateMailboxExists")
                    )
                  );
                }
              }
            }
          }
        }
        callback();
      },
      unitPrice: [
        {
          required: true,
          message: this.$t("schedulingAndPricing.pleaseEnterUnitPrice"),
          trigger: "blur"
        },
        {
          pattern: /^(0|([1-9][0-9]*)(\.\d+)?|0(\.\d+)?)$/,
          message: this.$t("schedulingAndPricing.priceFormatIsIncorrect"),
          trigger: "blur"
        }
      ],
      classLink: [
        {
          required: false,
          message: this.$t("schedulingAndPricing.pleaseEnterClassLink"),
          trigger: "blur"
        },
        {
          pattern: /^(http|https):\/\/([\w-]+\.)+[\w-]+(\/[\w-./#?%&=]*)?$/,
          message: this.$t("schedulingAndPricing.linkFormatIsIncorrect"),
          trigger: "blur"
        }
      ],
      dateAndTime: [
        {
          validator: dateAndTimeCheck,
          trigger: "change"
        }
      ],
      endDateAndTime: [
        {
          validator: endDateAndTimeCheck,
          trigger: "change"
        }
      ],
      linkPassword: [
        {
          required: false,
          message: this.$t("schedulingAndPricing.pleaseEnterLinkPassword"),
          trigger: "blur"
        }
      ],
      classAddress: [
        {
          required: true,
          message: this.$t("schedulingAndPricing.pleaseInClassAddress"),
          trigger: "blur"
        }
      ]
    };
  },
  methods: {
    // 初始化
   async init() {
      let url = "/api/schedulingAndPricing/initPricing";
      let p0311 = JSON.parse(sessionStorage.getItem("p0311"));
      await this.$http
        .post(url, {
          field: p0311.field,
          category: p0311.category,
          courseNumber: p0311.courseNumber
        })
        .then(response => {
          if (response.data.code === 200) {
            this.fieldOption.value = p0311.field;
            this.fieldOption.label = response.data.data.field;
            this.categoryOption.value = p0311.category;
            this.categoryOption.label = response.data.data.category;
            this.currencyList = response.data.data.currencyList;
            this.schedulingAndPricingForm.currency = "001";
            this.schedulingAndPricingForm.field = p0311.field;
            (this.schedulingAndPricingForm.category = p0311.category),
              (this.schedulingAndPricingForm.courseNumber =
                response.data.data.courseNumber);
            this.schedulingAndPricingForm.courseName =
              response.data.data.courseName;
            this.schedulingAndPricingForm.targetStudents =
              response.data.data.targetStudents;
            this.schedulingAndPricingForm.qualificationRequirements =
              response.data.data.qualificationRequirements;
            this.schedulingAndPricingForm.form = response.data.data.form;
            this.schedulingAndPricingForm.classLanguage =
              response.data.data.classLanguage;
            this.schedulingAndPricingForm.duration = this.editDuration(
              response.data.data.duration
            );
            this.duration = response.data.data.duration;
            this.schedulingAndPricingForm.numberLimit =
              response.data.data.numberLimit;
            this.schedulingAndPricingForm.certificate =
              response.data.data.certificate;
            this.schedulingAndPricingForm.coursewareLink =
              response.data.data.coursewareLink;
            this.schedulingAndPricingForm.classAddress =
              response.data.data.classAddress;
            this.schedulingAndPricingForm.formCode =
              response.data.data.formCode;
            this.formFlag = response.data.data.formCode != "02";
            this.formVal = response.data.data.formCode;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
   async initCourseOption(){
     await this.$http
        .post('/api/courseOption/init')
        .then(response => {
          if (response.data.code === 200) {
            this.selection = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 获取认证老师
    getCertifiedTrainers() {
      let url = "/api/schedulingAndPricing/certifiedTrainers";
      let p0311 = JSON.parse(sessionStorage.getItem("p0311"));
      this.$http
        .post(url, {
          field: p0311.field,
          category: p0311.category,
          courseNumber: p0311.courseNumber
        })
        .then(response => {
          if (response.data.code === 200) {
            this.certifiedTrainersOptions = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 新增老师
    add() {
      if (this.schedulingAndPricingForm.teachersData.length == 10) {
        return;
      }
      this.schedulingAndPricingForm.teachersData.push("");
    },

    // 删减老师
    subtract(index) {
      this.schedulingAndPricingForm.teachersData.splice(index, 1);
      let that = this;
      this.schedulingAndPricingForm.teachersData.forEach(function(
        value,
        index,
        array
      ) {
        that.$refs.schedulingAndPricingFormRef.validateField(
          `teachersData.${index}`
        );
      });
    },

    // 老师输入框光标移出
    teacherInputBlur(param) {
      let that = this;
      this.schedulingAndPricingForm.teachersData.forEach(function(
        value,
        index,
        array
      ) {
        if (param != index) {
          that.$refs.schedulingAndPricingFormRef.validateField(
            `teachersData.${index}`
          );
        }
      });
      that.$refs.schedulingAndPricingFormRef.validateField(
        `teachersData.${param}`
      );
    },

    // // 结束日期与时间计算
    // getEndDateTime() {
    //   let startTimeNum = parseInt(this.schedulingAndPricingForm.dateAndTime.getTime() / (1000 * 60));
    //   let endTimeNum = startTimeNum + parseInt(this.duration);
    //   this.schedulingAndPricingForm.endDateAndTime = new Date(endTimeNum * 1000 * 60);
    // },
    // 获取分钟
    getDurationList() {
      for (let i = 0; i < 60; i++) {
        this.durationList.push(i);
      }
    },
    // 获取小时
    getHours() {
      for (let i = 0; i < 12; i++) {
        this.hourList.push(i);
      }
    },
    // 获取天
    getDayList() {
      this.dayList.push(0);
      for (let i = 1; i <= 10; i = i + 0.5) {
        this.dayList.push(i);
      }
    },
    // 取得日期时间差
    getDateDiff() {
      if (
        this.schedulingAndPricingForm.dateAndTime == null ||
        this.schedulingAndPricingForm.dateAndTime == ""
      ) {
        return 0;
      }
      let startDate = parseInt(
        this.schedulingAndPricingForm.dateAndTime.getTime() /
          (1000 * 60 * 60 * 24)
      );
      let endDate = parseInt(
        this.schedulingAndPricingForm.endDateAndTime.getTime() /
          (1000 * 60 * 60 * 24)
      );
      return (endDate - startDate + 1) * 24 * 60;
    },

    // 提交
    handleSubmit() {
      this.$refs.schedulingAndPricingFormRef.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let url = "/api/schedulingAndPricing/submit";
          // 初始化老师的数据
          this.schedulingAndPricingForm.teacherUserIds = this.schedulingAndPricingForm.teachersData[0];
          // 循环拼接剩余的老师
          for (
            let i = 1;
            i < this.schedulingAndPricingForm.teachersData.length;
            i++
          ) {
            if (
              this.schedulingAndPricingForm.teachersData.length > 1 &&
              this.schedulingAndPricingForm.teachersData[i] != ""
            ) {
              this.schedulingAndPricingForm.teacherUserIds +=
                "," + this.schedulingAndPricingForm.teachersData[i];
            }
          }
          this.schedulingAndPricingForm.teachers = this.schedulingAndPricingForm.teachersData
            .filter(userId => userId !== "")
            .map(userId => {
              const teacher = this.certifiedTrainersOptions.find(
                teacher => teacher.userId === userId
              );
              return teacher ? `${teacher.lastName}${teacher.firstName}` : "";
            })
            .filter(name => name !== "")
            .join(",");
          this.schedulingAndPricingForm.dateAndTime = new Date(
            moment(this.schedulingAndPricingForm.dateAndTime).format(
              "YYYY-MM-DD HH:mm:00"
            )
          );
          this.schedulingAndPricingForm.endDateAndTime = new Date(
            moment(this.schedulingAndPricingForm.endDateAndTime).format(
              "YYYY-MM-DD HH:mm:00"
            )
          );
          this.schedulingAndPricingForm.createUser = localStorage.getItem(
            "userId"
          );
          this.schedulingAndPricingForm.classLink = this.schedulingAndPricingForm.classLink.trim();
          this.schedulingAndPricingForm.meetingId = this.schedulingAndPricingForm.meetingId.trim();
          this.schedulingAndPricingForm.coursewareLink = this.schedulingAndPricingForm.coursewareLink.trim();
          this.schedulingAndPricingForm.signUpLink = this.schedulingAndPricingForm.signUpLink.trim();
          this.schedulingAndPricingForm.linkPassword = this.schedulingAndPricingForm.linkPassword.trim();
          this.schedulingAndPricingForm.classType = this.radioButton;
          this.schedulingAndPricingForm.classAddress = this.schedulingAndPricingForm.classAddress;
          this.schedulingAndPricingForm.formCode = this.schedulingAndPricingForm.formCode;
          let durations = String(
            Number(this.days * 24 * 60) +
            Number(this.hours * 60) +
            Number(this.minutes)
          );
          this.schedulingAndPricingForm.duration = durations
          this.$http
            .post(url, this.schedulingAndPricingForm)
            .then(response => {
              if (response.data.code === 200) {
                this.schedulingAndPricingForm.unitPrice = "";
                this.schedulingAndPricingForm.currency = "001";
                this.schedulingAndPricingForm.unitPrice = "";
                this.radioButton = "0";
                this.schedulingAndPricingForm.classLink = "";
                this.schedulingAndPricingForm.teachersData = [""];
                this.schedulingAndPricingForm.dateAndTime = "";
                this.schedulingAndPricingForm.endDateAndTime = "";
                this.schedulingAndPricingForm.linkPassword = "";
                this.schedulingAndPricingForm.signUpLink = "";
                this.schedulingAndPricingForm.classAddress = "";
                this.$refs.schedulingAndPricingFormRef.clearValidate([
                  "unitPrice",
                  "unitPrice",
                  "classLink"
                ]);
                this.$nextTick(function() {
                  this.$refs.schedulingAndPricingFormRef.clearValidate([
                    "dateAndTime",
                    "endDateAndTime"
                  ]);
                });
                this.schedulingAndPricingForm.meetingId = "";
                this.signupSettingFlag(true)
                loading.close();
                this.$message.success(response.data.data);
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },

    // 返回
    handleReturn() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/views/GreenJacketForum/P0311",
        query: {
          courseName: this.$route.query.courseName,
          currentPagePr: this.$route.query.currentPagePr,
          totalPr: this.$route.query.totalPr,
          pageSizePr: this.$route.query.pageSizePr
        }
      });
    },

    // 编辑上课时长
    editDuration(value) {
      // 课程时长想改成天+小时+分钟---zhc
      let minuteTest = Number(value);
      // 取到分钟数
      let day = parseInt(minuteTest / 60 / 24 / 0.5) * 0.5;
      let hour = parseInt(minuteTest / 60 - day * 24);
      let min = parseInt(minuteTest - day * 24 * 60 - hour * 60);
      if (day > 0) {
        this.days = day;
      }
      if (hour > 0) {
        this.hours = hour;
      }
      if (min > 0) {
        this.minutes = min;
      }
    },
    // 定价
    changePrice0() {
      this.schedulingAndPricingForm.unitPrice = "";
      this.signupSettingFlag(true);
    },
    signupSettingFlag(flag) {
      this.schedulingAndPricingForm.signupSetting = {
        sexIsRequired: flag,
        phoneIsRequired: flag,
        companyIsRequired: flag,
        positionIsRequired: flag,
        birthdayIsRequired: flag
      };
    },
    changePrice1() {
      this.schedulingAndPricingForm.unitPrice = "0.00";
      this.schedulingAndPricingForm.signUpLink = "";
      this.$refs.schedulingAndPricingFormRef.clearValidate("unitPrice");
      this.$refs.schedulingAndPricingFormRef.clearValidate("signUpLink");
      this.signupSettingFlag(false);
    }
  },
  async mounted() {
   await this.initCourseOption()
   await this.init();
    this.getCertifiedTrainers();
    this.getDurationList();
    this.getHours();
    this.getDayList();
  }
};
</script>

<style lang="scss" scoped>
.foot-container {
  margin: 13px auto 0 auto;
  height: 26px;
  width: 14%;
  text-align: center;
}

// 加号图标的样式
.add-icon {
  float: left;
  position: relative;
  top: 13px;
  left: 10px;
  cursor: pointer;
}

// 减号图标的样式
.subtract-icon {
  float: left;
  position: relative;
  top: 18px;
  left: 9px;
  cursor: pointer;
}

// el-form-item的label的行高度
.formItem >>> .el-form-item__label {
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0312.vue